export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m3.5 18.48 6-6.01 4 4L22 6.91 20.59 5.5l-7.09 7.97-4-4L2 16.98z\"/>"
};